// extracted by css-extract-rspack-plugin
export default {"styledSvg":"TUUh_zKp","corner":"cXbjJBI9","messageButton":"pKdXL5KL","messageButtonDisabled":"MRjVGc1W"};